module.exports = __webpack_public_path__ + "OpenSans-SemiBold.0a74e46c16dc459aa726.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-SemiBold.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-SemiBold.eot
// module chunks = styles